/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ApplicationGovernanceAppAuthRpc';
import * as Queries from './ApplicationGovernanceAppAuthRpc.dfc.new';
import type { AdditionalContextArgs } from './ApplicationGovernanceAppAuthRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetApplicationGovernanceQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApplicationGovernanceResponseType>,
    References.GetApplicationGovernanceRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApplicationGovernance',
            References.GetApplicationGovernanceResponseType
          >
        : References.GetApplicationGovernanceResponseType)
    | undefined;
};

export function useGetApplicationGovernanceQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApplicationGovernanceResponseType>,
    References.GetApplicationGovernanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationGovernanceQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPLICATION_GOVERNANCE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApplicationGovernance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApplicationGovernanceQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApplicationGovernanceQueryReturn<T>;
}

type UseGetApplicationGovernanceLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApplicationGovernanceResponseType>,
    References.GetApplicationGovernanceRequestType,
    T extends true
      ? Record<
          'getApplicationGovernance',
          References.GetApplicationGovernanceResponseType
        >
      : References.GetApplicationGovernanceResponseType
  >;

export function useGetApplicationGovernanceLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApplicationGovernanceResponseType>,
    References.GetApplicationGovernanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationGovernanceLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPLICATION_GOVERNANCE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApplicationGovernance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApplicationGovernanceLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApplicationGovernanceLazyQueryReturn<T>;
}

type UseGetApplicationGovernanceSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetApplicationGovernanceResponseType>,
    References.GetApplicationGovernanceRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getApplicationGovernance',
        References.GetApplicationGovernanceResponseType
      >
    : References.GetApplicationGovernanceResponseType;
};

export function useGetApplicationGovernanceSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApplicationGovernanceResponseType>,
    References.GetApplicationGovernanceRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationGovernanceSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPLICATION_GOVERNANCE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApplicationGovernance: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApplicationGovernanceSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApplicationGovernanceSuspenseQueryReturn<T>;
}

type UseEnableApplicationInstallableMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.EnableApplicationInstallableResponseType>,
    References.EnableApplicationInstallableRequestType,
    T extends true
      ? Record<
          'enableApplicationInstallable',
          References.EnableApplicationInstallableResponseType
        >
      : References.EnableApplicationInstallableResponseType
  >;

export function useEnableApplicationInstallableMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.EnableApplicationInstallableResponseType>,
    References.EnableApplicationInstallableRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseEnableApplicationInstallableMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.ENABLE_APPLICATION_INSTALLABLE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            enableApplicationInstallable: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseEnableApplicationInstallableMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseEnableApplicationInstallableMutationReturn<T>;
}

type UseGetApprovedApplicationPaginatedQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApprovedApplicationPaginatedResponseType>,
    References.GetApprovedApplicationPaginatedRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApprovedApplicationPaginated',
            References.GetApprovedApplicationPaginatedResponseType
          >
        : References.GetApprovedApplicationPaginatedResponseType)
    | undefined;
};

export function useGetApprovedApplicationPaginatedQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetApprovedApplicationPaginatedResponseType>,
    References.GetApprovedApplicationPaginatedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovedApplicationPaginatedQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPROVED_APPLICATION_PAGINATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovedApplicationPaginated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovedApplicationPaginatedQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovedApplicationPaginatedQueryReturn<T>;
}

type UseGetApprovedApplicationPaginatedLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApprovedApplicationPaginatedResponseType>,
    References.GetApprovedApplicationPaginatedRequestType,
    T extends true
      ? Record<
          'getApprovedApplicationPaginated',
          References.GetApprovedApplicationPaginatedResponseType
        >
      : References.GetApprovedApplicationPaginatedResponseType
  >;

export function useGetApprovedApplicationPaginatedLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApprovedApplicationPaginatedResponseType>,
    References.GetApprovedApplicationPaginatedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovedApplicationPaginatedLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVED_APPLICATION_PAGINATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovedApplicationPaginated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApprovedApplicationPaginatedLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApprovedApplicationPaginatedLazyQueryReturn<T>;
}

type UseGetApprovedApplicationPaginatedSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetApprovedApplicationPaginatedResponseType>,
      References.GetApprovedApplicationPaginatedRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getApprovedApplicationPaginated',
          References.GetApprovedApplicationPaginatedResponseType
        >
      : References.GetApprovedApplicationPaginatedResponseType;
  };

export function useGetApprovedApplicationPaginatedSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApprovedApplicationPaginatedResponseType>,
    References.GetApprovedApplicationPaginatedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovedApplicationPaginatedSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVED_APPLICATION_PAGINATED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApprovedApplicationPaginated: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovedApplicationPaginatedSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovedApplicationPaginatedSuspenseQueryReturn<T>;
}

type UseRevokeApprovalMutationReturn<T extends boolean> = MutationTupleOverride<
  Record<'result', References.RevokeApprovalResponseType>,
  References.RevokeApprovalRequestType,
  T extends true
    ? Record<'revokeApproval', References.RevokeApprovalResponseType>
    : References.RevokeApprovalResponseType
>;

export function useRevokeApprovalMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.RevokeApprovalResponseType>,
    References.RevokeApprovalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRevokeApprovalMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REVOKE_APPROVAL_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            revokeApproval: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRevokeApprovalMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRevokeApprovalMutationReturn<T>;
}

type UseGetAppGovernancePermissionsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppGovernancePermissionsResponseType>,
    References.GetAppGovernancePermissionsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAppGovernancePermissions',
            References.GetAppGovernancePermissionsResponseType
          >
        : References.GetAppGovernancePermissionsResponseType)
    | undefined;
};

export function useGetAppGovernancePermissionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppGovernancePermissionsResponseType>,
    References.GetAppGovernancePermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppGovernancePermissionsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppGovernancePermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppGovernancePermissionsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppGovernancePermissionsQueryReturn<T>;
}

type UseGetAppGovernancePermissionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppGovernancePermissionsResponseType>,
    References.GetAppGovernancePermissionsRequestType,
    T extends true
      ? Record<
          'getAppGovernancePermissions',
          References.GetAppGovernancePermissionsResponseType
        >
      : References.GetAppGovernancePermissionsResponseType
  >;

export function useGetAppGovernancePermissionsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppGovernancePermissionsResponseType>,
    References.GetAppGovernancePermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppGovernancePermissionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppGovernancePermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppGovernancePermissionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppGovernancePermissionsLazyQueryReturn<T>;
}

type UseGetAppGovernancePermissionsSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAppGovernancePermissionsResponseType>,
      References.GetAppGovernancePermissionsRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAppGovernancePermissions',
          References.GetAppGovernancePermissionsResponseType
        >
      : References.GetAppGovernancePermissionsResponseType;
  };

export function useGetAppGovernancePermissionsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppGovernancePermissionsResponseType>,
    References.GetAppGovernancePermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppGovernancePermissionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppGovernancePermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppGovernancePermissionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppGovernancePermissionsSuspenseQueryReturn<T>;
}

type UseApproveAppGovernancePermissionsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.ApproveAppGovernancePermissionsResponseType>,
    References.ApproveAppGovernancePermissionsRequestType,
    T extends true
      ? Record<
          'approveAppGovernancePermissions',
          References.ApproveAppGovernancePermissionsResponseType
        >
      : References.ApproveAppGovernancePermissionsResponseType
  >;

export function useApproveAppGovernancePermissionsMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.ApproveAppGovernancePermissionsResponseType>,
    References.ApproveAppGovernancePermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseApproveAppGovernancePermissionsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.APPROVE_APP_GOVERNANCE_PERMISSIONS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            approveAppGovernancePermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseApproveAppGovernancePermissionsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseApproveAppGovernancePermissionsMutationReturn<T>;
}

type UseUpdateAllowedAppPermissionsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAllowedAppPermissionsResponseType>,
    References.UpdateAllowedAppPermissionsRequestType,
    T extends true
      ? Record<
          'updateAllowedAppPermissions',
          References.UpdateAllowedAppPermissionsResponseType
        >
      : References.UpdateAllowedAppPermissionsResponseType
  >;

export function useUpdateAllowedAppPermissionsMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAllowedAppPermissionsResponseType>,
    References.UpdateAllowedAppPermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAllowedAppPermissionsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_ALLOWED_APP_PERMISSIONS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAllowedAppPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAllowedAppPermissionsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAllowedAppPermissionsMutationReturn<T>;
}

type UseUpdateAllowedEntityTypeAndIdsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAllowedEntityTypeAndIdsResponseType>,
    References.UpdateAllowedEntityTypeAndIdsRequestType,
    T extends true
      ? Record<
          'updateAllowedEntityTypeAndIds',
          References.UpdateAllowedEntityTypeAndIdsResponseType
        >
      : References.UpdateAllowedEntityTypeAndIdsResponseType
  >;

export function useUpdateAllowedEntityTypeAndIdsMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAllowedEntityTypeAndIdsResponseType>,
    References.UpdateAllowedEntityTypeAndIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAllowedEntityTypeAndIdsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_ALLOWED_ENTITY_TYPE_AND_IDS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAllowedEntityTypeAndIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAllowedEntityTypeAndIdsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAllowedEntityTypeAndIdsMutationReturn<T>;
}

type UseGetApprovableAppsWithStatusQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApprovableAppsWithStatusResponseType>
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApprovableAppsWithStatus',
            References.GetApprovableAppsWithStatusResponseType
          >
        : References.GetApprovableAppsWithStatusResponseType)
    | undefined;
};

export function useGetApprovableAppsWithStatusQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApprovableAppsWithStatusResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovableAppsWithStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPROVABLE_APPS_WITH_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovableAppsWithStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovableAppsWithStatusQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovableAppsWithStatusQueryReturn<T>;
}

type UseGetApprovableAppsWithStatusLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApprovableAppsWithStatusResponseType>,
    {},
    T extends true
      ? Record<
          'getApprovableAppsWithStatus',
          References.GetApprovableAppsWithStatusResponseType
        >
      : References.GetApprovableAppsWithStatusResponseType
  >;

export function useGetApprovableAppsWithStatusLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApprovableAppsWithStatusResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovableAppsWithStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVABLE_APPS_WITH_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovableAppsWithStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApprovableAppsWithStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApprovableAppsWithStatusLazyQueryReturn<T>;
}

type UseGetApprovableAppsWithStatusSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetApprovableAppsWithStatusResponseType>
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getApprovableAppsWithStatus',
          References.GetApprovableAppsWithStatusResponseType
        >
      : References.GetApprovableAppsWithStatusResponseType;
  };

export function useGetApprovableAppsWithStatusSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApprovableAppsWithStatusResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovableAppsWithStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVABLE_APPS_WITH_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApprovableAppsWithStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovableAppsWithStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovableAppsWithStatusSuspenseQueryReturn<T>;
}

type UseRemoveAppPermissionsFromInstallsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.RemoveAppPermissionsFromInstallsResponseType>,
    References.RemoveAppPermissionsFromInstallsRequestType,
    T extends true
      ? Record<
          'removeAppPermissionsFromInstalls',
          References.RemoveAppPermissionsFromInstallsResponseType
        >
      : References.RemoveAppPermissionsFromInstallsResponseType
  >;

export function useRemoveAppPermissionsFromInstallsMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.RemoveAppPermissionsFromInstallsResponseType>,
    References.RemoveAppPermissionsFromInstallsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseRemoveAppPermissionsFromInstallsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.REMOVE_APP_PERMISSIONS_FROM_INSTALLS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            removeAppPermissionsFromInstalls: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseRemoveAppPermissionsFromInstallsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseRemoveAppPermissionsFromInstallsMutationReturn<T>;
}

type UseGetOrCreateConnectedAppObjectMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.GetOrCreateConnectedAppObjectResponseType>,
    References.GetOrCreateConnectedAppObjectRequestType,
    T extends true
      ? Record<
          'getOrCreateConnectedAppObject',
          References.GetOrCreateConnectedAppObjectResponseType
        >
      : References.GetOrCreateConnectedAppObjectResponseType
  >;

export function useGetOrCreateConnectedAppObjectMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.GetOrCreateConnectedAppObjectResponseType>,
    References.GetOrCreateConnectedAppObjectRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOrCreateConnectedAppObjectMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.GET_OR_CREATE_CONNECTED_APP_OBJECT_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOrCreateConnectedAppObject: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetOrCreateConnectedAppObjectMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetOrCreateConnectedAppObjectMutationReturn<T>;
}

type UseGetAppsGovernanceStatusQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppsGovernanceStatusResponseType>,
    References.GetAppsGovernanceStatusRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAppsGovernanceStatus',
            References.GetAppsGovernanceStatusResponseType
          >
        : References.GetAppsGovernanceStatusResponseType)
    | undefined;
};

export function useGetAppsGovernanceStatusQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppsGovernanceStatusResponseType>,
    References.GetAppsGovernanceStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppsGovernanceStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPS_GOVERNANCE_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppsGovernanceStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppsGovernanceStatusQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppsGovernanceStatusQueryReturn<T>;
}

type UseGetAppsGovernanceStatusLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppsGovernanceStatusResponseType>,
    References.GetAppsGovernanceStatusRequestType,
    T extends true
      ? Record<
          'getAppsGovernanceStatus',
          References.GetAppsGovernanceStatusResponseType
        >
      : References.GetAppsGovernanceStatusResponseType
  >;

export function useGetAppsGovernanceStatusLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppsGovernanceStatusResponseType>,
    References.GetAppsGovernanceStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppsGovernanceStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPS_GOVERNANCE_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppsGovernanceStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppsGovernanceStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppsGovernanceStatusLazyQueryReturn<T>;
}

type UseGetAppsGovernanceStatusSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAppsGovernanceStatusResponseType>,
    References.GetAppsGovernanceStatusRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAppsGovernanceStatus',
        References.GetAppsGovernanceStatusResponseType
      >
    : References.GetAppsGovernanceStatusResponseType;
};

export function useGetAppsGovernanceStatusSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppsGovernanceStatusResponseType>,
    References.GetAppsGovernanceStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppsGovernanceStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPS_GOVERNANCE_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppsGovernanceStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppsGovernanceStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppsGovernanceStatusSuspenseQueryReturn<T>;
}

type UseGetApprovedApplicationsForUserPagedQueryReturn<T extends boolean> =
  Omit<
    QueryResult<
      Record<
        'result',
        References.GetApprovedApplicationsForUserPagedResponseType
      >,
      References.GetApprovedApplicationsForUserPagedRequestType
    >,
    'data'
  > & {
    data:
      | (T extends true
          ? Record<
              'getApprovedApplicationsForUserPaged',
              References.GetApprovedApplicationsForUserPagedResponseType
            >
          : References.GetApprovedApplicationsForUserPagedResponseType)
      | undefined;
  };

export function useGetApprovedApplicationsForUserPagedQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<
      'result',
      References.GetApprovedApplicationsForUserPagedResponseType
    >,
    References.GetApprovedApplicationsForUserPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovedApplicationsForUserPagedQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovedApplicationsForUserPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovedApplicationsForUserPagedQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovedApplicationsForUserPagedQueryReturn<T>;
}

type UseGetApprovedApplicationsForUserPagedLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<
      'result',
      References.GetApprovedApplicationsForUserPagedResponseType
    >,
    References.GetApprovedApplicationsForUserPagedRequestType,
    T extends true
      ? Record<
          'getApprovedApplicationsForUserPaged',
          References.GetApprovedApplicationsForUserPagedResponseType
        >
      : References.GetApprovedApplicationsForUserPagedResponseType
  >;

export function useGetApprovedApplicationsForUserPagedLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<
      'result',
      References.GetApprovedApplicationsForUserPagedResponseType
    >,
    References.GetApprovedApplicationsForUserPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovedApplicationsForUserPagedLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovedApplicationsForUserPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApprovedApplicationsForUserPagedLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApprovedApplicationsForUserPagedLazyQueryReturn<T>;
}

type UseGetApprovedApplicationsForUserPagedSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<
      'result',
      References.GetApprovedApplicationsForUserPagedResponseType
    >,
    References.GetApprovedApplicationsForUserPagedRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getApprovedApplicationsForUserPaged',
        References.GetApprovedApplicationsForUserPagedResponseType
      >
    : References.GetApprovedApplicationsForUserPagedResponseType;
};

export function useGetApprovedApplicationsForUserPagedSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<
      'result',
      References.GetApprovedApplicationsForUserPagedResponseType
    >,
    References.GetApprovedApplicationsForUserPagedRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovedApplicationsForUserPagedSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApprovedApplicationsForUserPaged: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovedApplicationsForUserPagedSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovedApplicationsForUserPagedSuspenseQueryReturn<T>;
}

type UseGetListingIdsToExcludeQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetListingIdsToExcludeResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getListingIdsToExclude',
            References.GetListingIdsToExcludeResponseType
          >
        : References.GetListingIdsToExcludeResponseType)
    | undefined;
};

export function useGetListingIdsToExcludeQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetListingIdsToExcludeResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingIdsToExcludeQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LISTING_IDS_TO_EXCLUDE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingIdsToExclude: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingIdsToExcludeQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingIdsToExcludeQueryReturn<T>;
}

type UseGetListingIdsToExcludeLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetListingIdsToExcludeResponseType>,
    {},
    T extends true
      ? Record<
          'getListingIdsToExclude',
          References.GetListingIdsToExcludeResponseType
        >
      : References.GetListingIdsToExcludeResponseType
  >;

export function useGetListingIdsToExcludeLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetListingIdsToExcludeResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingIdsToExcludeLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LISTING_IDS_TO_EXCLUDE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingIdsToExclude: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetListingIdsToExcludeLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetListingIdsToExcludeLazyQueryReturn<T>;
}

type UseGetListingIdsToExcludeSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetListingIdsToExcludeResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getListingIdsToExclude',
        References.GetListingIdsToExcludeResponseType
      >
    : References.GetListingIdsToExcludeResponseType;
};

export function useGetListingIdsToExcludeSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetListingIdsToExcludeResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingIdsToExcludeSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LISTING_IDS_TO_EXCLUDE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getListingIdsToExclude: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingIdsToExcludeSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingIdsToExcludeSuspenseQueryReturn<T>;
}

type UseGetAppDataPermissionsStatusQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppDataPermissionsStatusResponseType>,
    References.GetAppDataPermissionsStatusRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAppDataPermissionsStatus',
            References.GetAppDataPermissionsStatusResponseType
          >
        : References.GetAppDataPermissionsStatusResponseType)
    | undefined;
};

export function useGetAppDataPermissionsStatusQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppDataPermissionsStatusResponseType>,
    References.GetAppDataPermissionsStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppDataPermissionsStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APP_DATA_PERMISSIONS_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppDataPermissionsStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppDataPermissionsStatusQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppDataPermissionsStatusQueryReturn<T>;
}

type UseGetAppDataPermissionsStatusLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppDataPermissionsStatusResponseType>,
    References.GetAppDataPermissionsStatusRequestType,
    T extends true
      ? Record<
          'getAppDataPermissionsStatus',
          References.GetAppDataPermissionsStatusResponseType
        >
      : References.GetAppDataPermissionsStatusResponseType
  >;

export function useGetAppDataPermissionsStatusLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppDataPermissionsStatusResponseType>,
    References.GetAppDataPermissionsStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppDataPermissionsStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_DATA_PERMISSIONS_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppDataPermissionsStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppDataPermissionsStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppDataPermissionsStatusLazyQueryReturn<T>;
}

type UseGetAppDataPermissionsStatusSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAppDataPermissionsStatusResponseType>,
      References.GetAppDataPermissionsStatusRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAppDataPermissionsStatus',
          References.GetAppDataPermissionsStatusResponseType
        >
      : References.GetAppDataPermissionsStatusResponseType;
  };

export function useGetAppDataPermissionsStatusSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppDataPermissionsStatusResponseType>,
    References.GetAppDataPermissionsStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppDataPermissionsStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_DATA_PERMISSIONS_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppDataPermissionsStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppDataPermissionsStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppDataPermissionsStatusSuspenseQueryReturn<T>;
}

type UseCheckAppInstallabilityQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.CheckAppInstallabilityResponseType>,
    References.CheckAppInstallabilityRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'checkAppInstallability',
            References.CheckAppInstallabilityResponseType
          >
        : References.CheckAppInstallabilityResponseType)
    | undefined;
};

export function useCheckAppInstallabilityQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.CheckAppInstallabilityResponseType>,
    References.CheckAppInstallabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckAppInstallabilityQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.CHECK_APP_INSTALLABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkAppInstallability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckAppInstallabilityQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseCheckAppInstallabilityQueryReturn<T>;
}

type UseCheckAppInstallabilityLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.CheckAppInstallabilityResponseType>,
    References.CheckAppInstallabilityRequestType,
    T extends true
      ? Record<
          'checkAppInstallability',
          References.CheckAppInstallabilityResponseType
        >
      : References.CheckAppInstallabilityResponseType
  >;

export function useCheckAppInstallabilityLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.CheckAppInstallabilityResponseType>,
    References.CheckAppInstallabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckAppInstallabilityLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.CHECK_APP_INSTALLABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkAppInstallability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCheckAppInstallabilityLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCheckAppInstallabilityLazyQueryReturn<T>;
}

type UseCheckAppInstallabilitySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.CheckAppInstallabilityResponseType>,
    References.CheckAppInstallabilityRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'checkAppInstallability',
        References.CheckAppInstallabilityResponseType
      >
    : References.CheckAppInstallabilityResponseType;
};

export function useCheckAppInstallabilitySuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.CheckAppInstallabilityResponseType>,
    References.CheckAppInstallabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckAppInstallabilitySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.CHECK_APP_INSTALLABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            checkAppInstallability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckAppInstallabilitySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseCheckAppInstallabilitySuspenseQueryReturn<T>;
}

type UseGetAppEmaStatusQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppEmaStatusResponseType>,
    References.GetAppEmaStatusRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getAppEmaStatus', References.GetAppEmaStatusResponseType>
        : References.GetAppEmaStatusResponseType)
    | undefined;
};

export function useGetAppEmaStatusQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppEmaStatusResponseType>,
    References.GetAppEmaStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppEmaStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_APP_EMA_STATUS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppEmaStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppEmaStatusQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetAppEmaStatusQueryReturn<T>;
}

type UseGetAppEmaStatusLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppEmaStatusResponseType>,
    References.GetAppEmaStatusRequestType,
    T extends true
      ? Record<'getAppEmaStatus', References.GetAppEmaStatusResponseType>
      : References.GetAppEmaStatusResponseType
  >;

export function useGetAppEmaStatusLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppEmaStatusResponseType>,
    References.GetAppEmaStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppEmaStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_EMA_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppEmaStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppEmaStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppEmaStatusLazyQueryReturn<T>;
}

type UseGetAppEmaStatusSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAppEmaStatusResponseType>,
    References.GetAppEmaStatusRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getAppEmaStatus', References.GetAppEmaStatusResponseType>
    : References.GetAppEmaStatusResponseType;
};

export function useGetAppEmaStatusSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppEmaStatusResponseType>,
    References.GetAppEmaStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppEmaStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_EMA_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppEmaStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppEmaStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppEmaStatusSuspenseQueryReturn<T>;
}

type UseUpdateAppEmaStatusMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateAppEmaStatusResponseType>,
    References.UpdateAppEmaStatusRequestType,
    T extends true
      ? Record<'updateAppEmaStatus', References.UpdateAppEmaStatusResponseType>
      : References.UpdateAppEmaStatusResponseType
  >;

export function useUpdateAppEmaStatusMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateAppEmaStatusResponseType>,
    References.UpdateAppEmaStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateAppEmaStatusMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_APP_EMA_STATUS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateAppEmaStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateAppEmaStatusMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateAppEmaStatusMutationReturn<T>;
}
